import type { VehicleFinance } from '@core/Entities/Vehicle/VehicleFinance.entity';
import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';
import { Typography } from '@gds/Typography/Typography';

import styles from './FinanceSummaryRow.module.css';

type Strings = {
  financeSummaryTermLabel: string;
  financeSummaryDepositLabel: string;
  financeSummaryMilesPerYearLabel: string;
  financeSummaryMonthsSuffix: string;
};

type Props = {
  finance: VehicleFinance;
  strings: Strings;
};

export const FinanceSummaryRow = ({ finance, strings }: Props) => {
  const { months, deposit, mileage } = finance;

  const items = [
    {
      value: `${months} ${strings.financeSummaryMonthsSuffix}`,
      label: strings.financeSummaryTermLabel,
    },
    {
      value: getFormattedCurrency(deposit, { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
      label: strings.financeSummaryDepositLabel,
    },
    { value: mileage?.toLocaleString('en-GB'), label: strings.financeSummaryMilesPerYearLabel },
  ];

  return (
    <div className={styles.summaryRow}>
      {items.map(({ value, label }) => (
        <div key={label} className={styles.summaryItem}>
          <Typography variant="body2" Component="span" className={styles.value}>
            {value}
          </Typography>
          <span className={styles.label}>{label}</span>
        </div>
      ))}
    </div>
  );
};
